import React, { useState } from "react";

import Button from "@atlaskit/button/new";
import { ButtonGroup } from "@atlaskit/button";
import { useDispatch, useSelector } from "react-redux";
import { saveFlow, setEditorSaved, selectFlow } from "../../../redux/actions/integrationActions";
import ConfirmModal from "../../../common/components/ConfirmModal";
import { toggleLoading } from "../../../redux/actions/messageActions";
import Tooltip from "@atlaskit/tooltip";

const FlowContentButtons = ({ variant }) => {
  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  const flows = useSelector((state) => state.integration.flows);
  const saved = useSelector((state) => state.integration.saved);
  const [isShowConfirmModal, setShowConfirmModal] = useState(false);

  const discardChanges = () => {
    setShowConfirmModal(false);
    const revert = flows.find((f) => f.id === flow.id);
    dispatch(setEditorSaved(true));
    dispatch(selectFlow({ ...revert }));
  };
  const onSave = () => {
    dispatch(toggleLoading(true, "Saving..."));
    dispatch(saveFlow(flow));
  };
  const onCancel = () => {
    if (saved) return;
    setShowConfirmModal(true);
  };

  return (
    <div className={`ihub-edit-save-bt-group ${variant === "action" ? "ihub-edit-save-bt-group-action" : ""}`.trim()}>
      <ButtonGroup>
        <Button appearance="link" onClick={onCancel} isDisabled={saved}>
          Cancel
        </Button>
        <Tooltip content="Press ctr+s to Save">
          <Button appearance="primary" onClick={onSave} isDisabled={saved}>
            Save
          </Button>
        </Tooltip>
      </ButtonGroup>
      <ConfirmModal
        action={"discard the changes"}
        targetName={flow.name}
        targetId={flow.id}
        isOpen={isShowConfirmModal}
        onAction={discardChanges}
        onClose={() => setShowConfirmModal(false)}
      />
    </div>
  );
};
export default FlowContentButtons;
